export const translateExciseClaimStatus = (status, t) => {
  if (!status) {
    return t("Pending");
  }

  const normalized = String(status).trim().toLowerCase();

  if (normalized === "pending") {
    return t("Pending");
  }

  if (normalized === "finished") {
    return t("Finished");
  }

  if (normalized === "prefinanced" || normalized === "pre-financed") {
    return t("Pre-Financed");
  }

  if (normalized === "rejected") {
    return t("Rejected");
  }

  if (normalized === "partly_rejected") {
    return t("(Partly) Rejected");
  }

  return t(status);
};
